/*
 * Mobile - Homepage - Brand Carousel  --  variant: Upper Placement
 * Moonshot experiment id: PE-33a7b9d0-fb01-4ac4-89b3-7375ec1a3ea6   status in Moonshot on 2026-08-27: DEPLOYED   started: 2026-06-15
 * Audience: MOBILE   Target: homepage   (see MGExp.targets in mg-exp-runtime.js)
 * Source: verbatim variant code from cdn.moonshot-ai.com/snippets/36780565.js (prettified);
 *         only change is window.msaiTools._msaiRunVariantBlock -> MGExp.runVariantBlock.
 * Enabled by theme setting: mgexp_home_m_brand_carousel
 */
MGExp.run('home_m_brand_carousel', { name: "Mobile - Homepage - Brand Carousel / Upper Placement", platform: 'mobile', target: 'homepage' }, function () {
  !(function () {
    let t = [".slick-track > img"],
      e = [];
    function n(t) {
      return (
        t.variants &&
        t.variants.some(function (t) {
          return !1 !== t.available;
        })
      );
    }
    const i = [
        { name: "Louis Vuitton", slug: "louis-vuitton" },
        { name: "Chanel", slug: "chanel" },
        { name: "Hermès", slug: "hermes" },
        { name: "Tiffany & Co.", slug: "tiffany-co" },
        { name: "Cartier", slug: "cartier" },
        { name: "Gucci", slug: "gucci" },
        { name: "Van Cleef & Arpels", slug: "van-cleef-arpels" },
        { name: "Goyard", slug: "goyard-handbags" },
      ],
      a = {};
    function o(t) {
      if (!t.variants || !t.variants.length) return 1 / 0;
      const e = t.variants.map(function (t) {
        const e = "string" == typeof t.price ? parseFloat(t.price) : t.price;
        return isNaN(e) ? 1 / 0 : e;
      });
      return Math.min.apply(null, e);
    }
    function r(t) {
      if (a[t]) return Promise.resolve(a[t]);
      const e =
        (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
        "/";
      return fetch(e + "collectsions/" + t + "/products.json?limit=30")
        .then(function (t) {
          if (!t.ok) throw new Error("Fetch failed: " + t.status);
          return t.json();
        })
        .then(function (e) {
          if (!e.products || 0 === e.products.length) return [];
          const i = (function (t) {
            if (t.length <= 7) return t;
            const e = [],
              n = {};
            function i(t) {
              return !n[t.id] && ((n[t.id] = !0), e.push(t), !0);
            }
            let a = 0;
            for (let e = 0; e < t.length && a < 3; e++) i(t[e]) && a++;
            const r = t.slice().sort(function (t, e) {
              return o(t) - o(e);
            });
            let s = 0;
            for (let t = 0; t < r.length && s < 2; t++) i(r[t]) && s++;
            const c = t.slice().sort(function (t, e) {
              return new Date(e.created_at) - new Date(t.created_at);
            });
            let l = 0;
            for (let t = 0; t < c.length && l < 2; t++) i(c[t]) && l++;
            for (let n = 0; n < t.length && e.length < 7; n++) i(t[n]);
            return e.slice(0, 7);
          })(e.products.filter(n));
          return ((a[t] = i), i);
        })
        .catch(function () {
          return [];
        });
    }
    function s(t) {
      const e = document.createElement("div");
      e.className = "msai-multi-bc-card";
      const n = (function (t) {
          if (!t || !t.length) return "";
          const e = t[0];
          return (
            (n = "string" == typeof e ? e : e.src),
            (i = 400),
            (n ? n.split("?")[0] + "?width=" + (i || 400) : null) || ""
          );
          var n, i;
        })(t.images),
        i = document.createElement("div");
      if (((i.className = "msai-multi-bc-card-img"), n)) {
        const e = document.createElement("img");
        ((e.src = n),
          (e.alt = t.title || ""),
          (e.loading = "lazy"),
          i.appendChild(e));
      }
      e.appendChild(i);
      const a = document.createElement("p");
      ((a.className = "msai-multi-bc-card-vendor"),
        (a.textContent = t.vendor || ""),
        e.appendChild(a));
      let o = t.title || "";
      t.vendor &&
        0 === o.indexOf(t.vendor) &&
        (o = o.substring(t.vendor.length).replace(/^[\s\-–—]+/, ""));
      const r = document.createElement("p");
      ((r.className = "msai-multi-bc-card-title"),
        (r.textContent = o),
        e.appendChild(r));
      const s = t.variants && t.variants[0] ? t.variants[0].price : null,
        c = document.createElement("span");
      ((c.className = "msai-multi-bc-card-price"),
        (c.textContent = (function (t) {
          if (null == t) return "";
          let e = "string" == typeof t ? parseFloat(t) : t;
          return isNaN(e)
            ? ""
            : (Number.isInteger(e) && e > 9999 && (e /= 100),
              "$" +
                e.toLocaleString("en-US", {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                }));
        })(s)),
        e.appendChild(c));
      const l = document.createElement("a");
      return (
        (l.href = "/products/" + t.handle),
        (l.className = "msai-multi-bc-card-link"),
        l.setAttribute("aria-label", t.title || ""),
        e.appendChild(l),
        e
      );
    }
    !(async function (n, i, a, o, r) {
      let s = {
        multi_target_selectors: t,
        exclude_from_timeout: e,
        selector_timeout: 5e3,
      };
      await MGExp.runVariantBlock(n, i, a, o, r, s);
    })(
      ["#shopify-section-as-seen-in"],
      ".msai-bc-initialized",
      function (t, e) {
        const [n] = e;
        let a = 0,
          o = !1;
        const c = document.createElement("div");
        c.className = "msai-bc-wrapper";
        const l = document.createElement("h2");
        ((l.className = "msai-bc-heading"),
          (l.textContent = "Shop by Brand"),
          c.appendChild(l));
        const d = document.createElement("div");
        ((d.className = "msai-bc-tabs"), d.setAttribute("role", "tablist"));
        const m = [];
        (i.forEach(function (t, e) {
          const n = document.createElement("button");
          ((n.className = "msai-multi-bc-tab"),
            n.setAttribute("role", "tab"),
            n.setAttribute("data-active", 0 === e ? "true" : "false"),
            (n.textContent = t.name),
            n.addEventListener("click", function () {
              b(e);
            }),
            d.appendChild(n),
            m.push(n));
        }),
          c.appendChild(d));
        const p = document.createElement("div");
        ((p.className = "msai-bc-product-area"), c.appendChild(p));
        const u = document.createElement("div");
        u.className = "msai-bc-footer";
        const f = document.createElement("a");
        function b(t) {
          if (t === a && o) return;
          ((a = t),
            m.forEach(function (e, n) {
              e.setAttribute("data-active", n === t ? "true" : "false");
            }));
          const e = (d.clientWidth - m[t].clientWidth) / 2;
          (d.scrollTo({ left: m[t].offsetLeft - e, behavior: "smooth" }),
            (f.textContent = "Shop All " + i[t].name),
            (f.href = "/collectsions/" + i[t].slug),
            p.replaceChildren(),
            (o = !1));
          const n = document.createElement("div");
          n.className = "msai-bc-loading";
          const c = document.createElement("div");
          ((c.className = "msai-bc-spinner"),
            n.appendChild(c),
            p.appendChild(n),
            r(i[t].slug).then(function (e) {
              if (a !== t) return;
              if ((p.replaceChildren(), 0 === e.length)) {
                const t = document.createElement("div");
                return (
                  (t.className = "msai-bc-empty"),
                  (t.textContent = "No products available"),
                  void p.appendChild(t)
                );
              }
              const n = document.createElement("div");
              ((n.className = "msai-bc-row"),
                e.forEach(function (t) {
                  n.appendChild(s(t));
                }),
                p.appendChild(n),
                (o = !0));
            }));
        }
        ((f.className = "msai-bc-shop-all btn-transparent mt-3 md:mt-0"),
          (f.textContent = "Shop All " + i[0].name),
          (f.href = "/collectsions/" + i[0].slug),
          u.appendChild(f),
          c.appendChild(u),
          n.parentNode.insertBefore(c, n.nextSibling),
          b(0),
          setTimeout(function () {
            i.forEach(function (t, e) {
              0 !== e && r(t.slug);
            });
          }, 1500),
          c.classList.add("msai-bc-initialized"));
      },
      '.msai-bc-wrapper{padding:40px 0;background:white}.msai-bc-heading{font-family:"Playfair Display",serif;font-weight:400;font-size:32px;line-height:1.2;color:#000;text-align:center;margin:0 0 20px;padding:0 16px}.msai-bc-tabs{display:flex;overflow-x:auto;-webkit-overflow-scrolling:touch;gap:0;padding:0 16px;margin-bottom:20px;scrollbar-width:none;border-bottom:1px solid #e0e0e0}.msai-bc-tabs::-webkit-scrollbar{display:none}.msai-multi-bc-tab{flex:0 0 auto;padding:10px 16px;font-family:Raleway,sans-serif;font-size:13px;font-weight:500;color:#666;background:none;border:none;border-bottom:2px solid transparent;cursor:pointer;white-space:nowrap;transition:color 0.2s,border-color 0.2s;-webkit-tap-highlight-color:transparent}.msai-multi-bc-tab:active{opacity:0.7}.msai-multi-bc-tab[data-active="true"]{color:#000;font-weight:600;border-bottom-color:#000}.msai-bc-product-area{position:relative;margin-bottom:20px}.msai-bc-row{display:flex;overflow-x:auto;-webkit-overflow-scrolling:touch;gap:12px;padding:0 16px 8px;margin-left:8px;scroll-snap-type:x mandatory;scrollbar-width:none}.msai-bc-row::-webkit-scrollbar{display:none}.msai-bc-loading{display:flex;align-items:center;justify-content:center;height:280px;width:100%}.msai-bc-spinner{width:28px;height:28px;border:2px solid #e0e0e0;border-top-color:#000;border-radius:50%;animation:msai-bc-spin 0.7s linear infinite}@keyframes msai-bc-spin{to{transform:rotate(360deg)}}.msai-multi-bc-card{flex:0 0 auto;width:165px;background:#fff;border-radius:8px;padding:10px;position:relative;scroll-snap-align:start}.msai-multi-bc-card-img{width:100%;aspect-ratio:1 / 1;margin-bottom:8px;overflow:hidden;border-radius:4px;background:#fafafa}.msai-multi-bc-card-img img{display:block;width:100%;height:100%;object-fit:cover}.msai-multi-bc-card-vendor{font-family:Raleway,sans-serif;font-size:10px;font-weight:400;color:#888;margin:0 0 2px;line-height:1.3}.msai-multi-bc-card-title{font-family:Raleway,sans-serif;font-size:12px;font-weight:400;color:#1a1a1a;margin:0 0 6px;line-height:1.35;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}.msai-multi-bc-card-price{font-family:Raleway,sans-serif;font-size:13px;font-weight:600;color:#000;display:block}.msai-multi-bc-card-link{position:absolute;inset:0;z-index:1}.msai-bc-footer{text-align:center;padding:4px 16px 0}.msai-bc-empty{text-align:center;padding:40px 16px;color:#888;font-family:Raleway,sans-serif;font-size:14px}.seen-slider,.slick-track{background:#fafafa}.slick-track > img{mix-blend-mode:multiply !important}',
    );
  })();
});
